import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/monitor/images/icon01.png'
import _imports_1 from '@/assets/monitor/images/icon03.png'
import _imports_2 from '@/assets/monitor/images/icon05.png'
import _imports_3 from '@/assets/monitor/images/icon06.png'


const _withScopeId = n => (_pushScopeId("data-v-e8f0225c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-layout" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 设备运行状态监控 ")
const _hoisted_5 = {
  id: "localtime",
  style: {"font-size":"1rem","position":"absolute","right":"60px","top":"-10px"}
}
const _hoisted_6 = { id: "content" }
const _hoisted_7 = { class: "content_left" }
const _hoisted_8 = { class: "left-top" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "device_name" }
const _hoisted_11 = { class: "device_count" }
const _hoisted_12 = { class: "left-bottom" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("　设备运行情况")
], -1))
const _hoisted_14 = { class: "charts charts-container" }
const _hoisted_15 = { class: "content_center" }
const _hoisted_16 = { class: "center_top" }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode("　 ")
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("　 ")
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_25 = { class: "charts charts-container" }
const _hoisted_26 = { class: "charts-table row" }
const _hoisted_27 = { class: "info-box bg-table" }
const _hoisted_28 = { class: "info-box-icon" }
const _hoisted_29 = { class: "info-box-content" }
const _hoisted_30 = { class: "info-box-text" }
const _hoisted_31 = { class: "info-box-number" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "progress" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "progress-bar",
    style: {"width":"70%"}
  })
], -1))
const _hoisted_33 = { class: "progress-description" }
const _hoisted_34 = { style: {"position":"absolute","right":"2rem","bottom":"1rem"} }
const _hoisted_35 = { class: "btn-group-vertical" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "center_bot" }
const _hoisted_38 = { class: "panel-wrapper" }
const _hoisted_39 = { class: "panel-table" }
const _hoisted_40 = { class: "panel-table-header" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"50px"} }, "序号", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"160px"} }, "日期", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"50px"} }, "层", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"50px"} }, "级别", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"50px"} }, "模块", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"50px"} }, "状态", -1))
const _hoisted_47 = { class: "panel-table-body" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "7" }, "无", -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = { class: "content_right" }
const _hoisted_52 = { class: "report" }
const _hoisted_53 = { class: "report1" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "工单信息", -1))
const _hoisted_55 = { class: "report2" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "监控信息", -1))
const _hoisted_57 = { class: "news_report" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("　工单信息")
], -1))
const _hoisted_59 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_60 = { class: "clearfix" }
const _hoisted_61 = { style: {"float":"right","font-size":"1.1rem"} }
const _hoisted_62 = { style: {"float":"left"} }
const _hoisted_63 = { style: {"float":"right"} }
const _hoisted_64 = { class: "news_report" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("　监控信息")
], -1))
const _hoisted_66 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_67 = { class: "clearfix" }
const _hoisted_68 = { style: {"float":"right","font-size":"1.1rem"} }
const _hoisted_69 = { style: {"float":"left"} }
const _hoisted_70 = { style: {"float":"right"} }

export function render(_ctx, _cache) {
  const _component_app_content_header = _resolveComponent("app-content-header")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_EchartsRunPie = _resolveComponent("EchartsRunPie")
  const _component_EchartsMap = _resolveComponent("EchartsMap")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_content_header),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "card card-flex",
          style: _normalizeStyle({position: _ctx.menuAndHeaderCollapsed?'unset':'relative'})
        }, [
          _createElementVNode("div", {
            id: "main-layer",
            class: "card-body",
            style: _normalizeStyle({height: _ctx.menuAndHeaderCollapsed?'100vh':'100%'})
          }, [
            _createElementVNode("header", null, [
              _hoisted_4,
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.currentDateTime), 1),
              _createVNode(_component_svg_icon, {
                name: _ctx.menuAndHeaderCollapsed?'contract-outline':'expand-outline',
                onClick: _ctx.onToggleMenuAndHeader,
                class: "hand",
                style: {"position":"absolute","right":"30px","top":"30px","transform":"rotate(90deg)"}
              }, null, 8, ["name", "onClick"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eChartData.projectTotal, (item, key) => {
                    return (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                      _createElementVNode("li", _hoisted_10, _toDisplayString(key), 1),
                      _createElementVNode("li", _hoisted_11, _toDisplayString(`${item["转运中心"] + item["加盟公司"]} / ${item["转运中心"]} / ${item["加盟公司"]}`), 1)
                    ]))
                  }), 256))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_EchartsRunPie, {
                      ref: "echartsRunPie",
                      modelValue: this.eChartData,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((this.eChartData) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _hoisted_19,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eChartData.workJsonList, (item, key) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                        (key < _ctx.eChartData.workJsonList.length - 1)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "hand",
                              onClick: $event => (_ctx.reloadMap(item.name, item.adcode, item.work))
                            }, _toDisplayString(item.name), 9, _hoisted_20))
                          : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(item.name), 1)),
                        (key !== _ctx.eChartData.workJsonList.length - 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, " / "))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128)),
                    _hoisted_23,
                    _hoisted_24
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _withDirectives(_createVNode(_component_EchartsMap, {
                      ref: "echartsMap",
                      modelValue: _ctx.eChartData,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.eChartData) = $event)),
                      "onClick:drilldown": _ctx.mapDrillDown
                    }, null, 8, ["modelValue", "onClick:drilldown"]), [
                      [_vShow, !_ctx.eChartData.isBox]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_26, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eChartData.boxMapData, (item, key) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: key,
                          class: "col-md-3 col-sm-6 col-12"
                        }, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("span", _hoisted_28, [
                              _createVNode(_component_svg_icon, {
                                size: "lg",
                                name: "bookmark-outline"
                              })
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("span", _hoisted_30, _toDisplayString(item.orgName), 1),
                              _createElementVNode("span", _hoisted_31, _toDisplayString(item.value), 1),
                              _hoisted_32,
                              _createElementVNode("span", _hoisted_33, _toDisplayString(item.deviceId), 1)
                            ])
                          ])
                        ]))
                      }), 128))
                    ], 512), [
                      [_vShow, _ctx.eChartData.isBox]
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableLabelArray, (labelName, index) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: index,
                            type: "button",
                            class: _normalizeClass(["btn", _ctx.eChartData.currentTableIndex===index?'btn-themes':'btn-dark']),
                            onClick: $event => (_ctx.changeTable(index))
                          }, _toDisplayString(`${labelName}`), 11, _hoisted_36))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("table", _hoisted_39, [
                      _createElementVNode("thead", _hoisted_40, [
                        _createElementVNode("tr", null, [
                          _hoisted_41,
                          _hoisted_42,
                          _createElementVNode("th", null, _toDisplayString(_ctx.eChartData.currentTableTitle) + " (" + _toDisplayString(_ctx.eChartData.currentTableCount) + ")", 1),
                          _hoisted_43,
                          _hoisted_44,
                          _hoisted_45,
                          _hoisted_46
                        ])
                      ]),
                      _createElementVNode("tbody", _hoisted_47, [
                        (_ctx.eChartData.currentTableCount < 1)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_48, _hoisted_50))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eChartData.currentTableData, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                            _createElementVNode("td", null, _toDisplayString(item.productionDatetime), 1),
                            _createElementVNode("td", null, _toDisplayString(item.projectIdName), 1),
                            _createElementVNode("td", null, _toDisplayString(item.machineLayer), 1),
                            _createElementVNode("td", null, _toDisplayString(item.level), 1),
                            _createElementVNode("td", null, _toDisplayString(item.moduleName), 1),
                            _createElementVNode("td", null, _toDisplayString(item.statusName), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _hoisted_54,
                    _createElementVNode("small", null, _toDisplayString(_ctx.eChartData.workOrder.length) + " 条", 1)
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _hoisted_56,
                    _createElementVNode("small", null, _toDisplayString(_ctx.eChartData.monitorMessageCount) + " 条", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _hoisted_58,
                  _createElementVNode("div", {
                    class: _normalizeClass(["news_list list1", _ctx.menuAndHeaderCollapsed?'content_expand':'content_collapse'])
                  }, [
                    _createElementVNode("ul", null, [
                      (_ctx.eChartData.workOrder.length < 1)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_59, "无"))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eChartData.workOrder, (item, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: index,
                          class: "li02"
                        }, [
                          _createElementVNode("div", _hoisted_60, [
                            _createTextVNode(_toDisplayString(`${item.orgName}(${item.cockpitCode})`) + " ", 1),
                            _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.$tools.formatSimpleTime2(item.createTime)), 1)
                          ]),
                          _createElementVNode("div", {
                            class: "clearfix",
                            style: _normalizeStyle({color:item.status === 0?'red':'#aaaaaa'})
                          }, [
                            _createElementVNode("div", _hoisted_62, _toDisplayString(item.workSubject), 1),
                            _createElementVNode("div", _hoisted_63, _toDisplayString(item.createName), 1)
                          ], 4)
                        ]))
                      }), 128))
                    ])
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _createElementVNode("div", {
                    class: _normalizeClass(["news_list list2", _ctx.menuAndHeaderCollapsed?'content_expand':'content_collapse'])
                  }, [
                    _createElementVNode("ul", null, [
                      (_ctx.eChartData.monitorMessageTopList.length < 1)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_66, "无"))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eChartData.monitorMessageTopList, (item, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: index,
                          class: "li02"
                        }, [
                          _createElementVNode("div", _hoisted_67, [
                            _createTextVNode(_toDisplayString(`${item.orgName}(${item.deviceId})`) + " ", 1),
                            _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.$tools.formatSimpleTime2(item.productionDatetime)), 1)
                          ]),
                          _createElementVNode("div", {
                            class: "clearfix",
                            style: _normalizeStyle({color:item.status === 0?'red':'#aaaaaa'})
                          }, [
                            _createElementVNode("div", _hoisted_69, _toDisplayString(`${item.machineLayer}层-${item.moduleName}`), 1),
                            _createElementVNode("div", _hoisted_70, _toDisplayString(item.statusName), 1)
                          ], 4)
                        ]))
                      }), 128))
                    ])
                  ], 2)
                ])
              ])
            ])
          ], 4)
        ], 4)
      ])
    ])
  ]))
}